export default "__VITE_ASSET__691b7c19__"